import { render } from "./popoverComponentRestApiAction.vue?vue&type=template&id=e87743fa&scoped=true"
import script from "./popoverComponentRestApiAction.vue?vue&type=script&lang=js"
export * from "./popoverComponentRestApiAction.vue?vue&type=script&lang=js"

import "./popoverComponentRestApiAction.vue?vue&type=style&index=0&id=e87743fa&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87743fa"]])

export default __exports__